import React, { useState, useEffect, useRef } from "react";
import Tab5Image from "../img/envision/manufacturing/business aligned.jpg";
import Tab4Image from "../img/envision/manufacturing/manfaturetabtwo/cloudadptionman.jpg";
import Tab3Image from "../img/envision/manufacturing/cybersecontabmanu.jpg";
import Tab2Image from "../img/envision/manufacturing/quality-manufacturing.jpg";
import Tab1Image from "../img/envision/manufacturing/moder manufacturing.jpg";
// import Tab5Image from "../img/envision/aerospace/tabsimages/[freepicdownloader.com]-generative-ai-military-fighter-jets-patrol-air-launch-missiles-medium.jpg";
// import Tab6Image from "../img/envision/aerospace/tabsimages/jhkk.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCar, faTruck, faGear, faMicrochip, faSlidersH, faWifi, faCogs, faCloud, faVial, faTablet, faNetworkWired, faDesktop, faLaptop } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const Manufacturingthirdtab = () => {
    const [activeTab, setActiveTab] = useState("tab1");
    const [isAutoPlayActive, setIsAutoPlayActive] = useState(true); // State to manage autoplay
const tabContainerRef = useRef(null);

    // const handleTabClick = (tab) => setActiveTab(tab);

    const navigate = useNavigate(); // Initialize navigate

    const handleKnowMoreClick = () => {
        // Navigate to the documentaerospacepage with the specific hash
        navigate("/documnetmanufacturepage#documnetmanufacturepageSEeconddata");
    };
    const [isHovered, setIsHovered] = useState(false);
    const handleTabClick = (tabId) => {
        setActiveTab(tabId);
        setIsAutoPlayActive(false); // Stop auto-play when tab is clicked
    };
    // Autoplay effect to change tabs every 3 seconds (3000ms)
    useEffect(() => {
        let tabInterval;

        if (!isHovered && isAutoPlayActive) {
            tabInterval = setInterval(() => {
                setActiveTab((prevTab) => {
                    const nextTabNum = parseInt(prevTab.replace("tab", "")) % 5 + 1;
                    return `tab${nextTabNum}`;
                });
            }, 3000);
        }

        return () => clearInterval(tabInterval);
    }, [activeTab, isHovered, isAutoPlayActive]);


    const styles = {
        container: {
            fontFamily: "Arial, sans-serif",
            // display: "flex",
            width: "80%",
            margin: "50px auto",
        },
        tabNav: {
            // display: "flex",
            flexDirection: "column",
            borderRight: "1px solid #fff",
            height: "380px",
            overflowY: "auto", // Ensure only vertical scrolling
            scrollbarWidth: "thin", // For Firefox
            scrollbarColor: "#ccc transparent", // For Firefox
            direction: "rtl", // This makes the scrollbar appear on the left side
        },

        tabButton: {
            padding: "25px",
            cursor: "pointer",
            border: "none",
            background: "none",
            fontSize: "16px",
            fontWeight: "bold",
            color: "#555",
            outline: "none",
            transition: "color 0.3s, background-color 0.3s",
            borderRadius: "10px",
            margin: "5px 0",
            backgroundColor: "#f0f0f0",
        },
        activeTabButton: {
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
        },
        card: {
            // display: "flex",
            alignItems: "center",
            padding: "20px",
            borderRadius: "15px",
            backgroundColor: "#fff",
            boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
            width: "100%",
            // marginLeft: "10px",
            cursor: "pointer",
            height: "400px",
            overflowY: "auto"
        },
        image: {
            width: "382px",
            height: "354px",
            borderRadius: "10px",
            marginRight: "20px",
        },
        textContent: {
            flex: 1,
            textAlign: "left",
            color: "#333",
            // marginTop:"330px"
            height:"805px"
        },
        icon: {
            marginRight: "10px",
            fontSize: "24px",
            color: "#009ca5",
        },
        dotNav: {
            display: "flex",
            justifyContent: "center",
            marginTop: "10px",
        },
        dot: {
            width: "10px",
            height: "10px",
            borderRadius: "50%",
            backgroundColor: "#ccc",
            margin: "0 5px",
            cursor: "pointer",
            transition: "background-color 0.3s",
        },
        activeDot: {
            backgroundColor: "rgb(236 115 34)",
        },
        knowMoreButton: {
            marginTop: "15px",
            padding: "10px 20px",
            backgroundColor: "rgb(236 115 34)",
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            cursor: "pointer",
            fontSize: "16px",
            transition: "background-color 0.3s",
            // marginLeft: "150px"
        },
        knowMoreButtonHover: {
            backgroundColor: "#e68a00",
        },
    };

    return (
        <div style={{ marginTop: '100px' }}>
            <h1 style={{ textAlign: "center" }}>
                <span style={{ color: "rgb(236 115 34)" }}>Gen AI enabled IT & OT  </span> Transformation Services
            </h1>

            <div style={styles.container} className="tabclass-container-data">
                {/* Tab Navigation */}
              

                <div
                    style={{
                        ...styles.tabNav,
                        overflowY: 'auto', // Allow scrolling within the container
                        scrollBehavior: 'smooth', // Enable smooth scrolling within the container
                    }}
                    ref={tabContainerRef}
                    className="tabdata"
                >
                    {[
                        'SECURED & MODERN INFRASTRUCTURE for manufacturing',
                        'ROBUST DISASTER RECOVERY & BUSINESS CONTINUITY',
                        'Transformed Applications (ERP & IT Modernization)',
                        'CLOUD ADOPTION',
                        'BUSINESS-ALIGNED IT & SECURITY',
           
                    ].map((tab, index) => {
                        const tabId = `tab${index + 1}`;
                        return (
                            <button
                                key={tabId}
                                id={tabId}
                                style={{
                                    ...styles.tabButton,
                                    ...(activeTab === tabId
                                        ? { ...styles.activeTabButton, backgroundColor: 'rgb(236 115 34)', color: '#fff' }
                                        : {}),
                                }}
                                onClick={() => handleTabClick(tabId)}
                                className="tab-button-width"
                                onMouseEnter={(e) => {
                                    if (activeTab !== tabId) {
                                        e.currentTarget.style.backgroundColor = '#000'; // Change background to black on hover
                                        e.currentTarget.style.color = '#fff'; // Change text to white on hover
                                    }
                                }}
                                onMouseLeave={(e) => {
                                    if (activeTab !== tabId) {
                                        e.currentTarget.style.backgroundColor = ''; // Revert background on mouse leave
                                        e.currentTarget.style.color = ''; // Revert text color on mouse leave
                                    }
                                }}
                            >
                                {tab}
                            </button>
                        );
                    })}
                </div>

                {/* Tab Content */}
                <div style={styles.card} className="card-data-vertica-tabs" onMouseEnter={() => setIsHovered(true)}
                    onMouseLeave={() => setIsHovered(false)}>
                    <img
                        src={{ tab1: Tab1Image, tab2: Tab2Image, tab3: Tab3Image, tab4: Tab4Image, tab5: Tab5Image }[activeTab]}
                        alt="Aerospace"
                        style={styles.image}
                        className="tab-image-data"
                    />
                    <div style={styles.textContent}
                    //  className="manu-tridi-data"
                    className={`manu-tridi-data 
                        ${activeTab === "tab1" ? "tab1-largesmm-screen-margin" : ""} 
                        ${activeTab === "tab2" ? "tab2-largesmm-screen-margin" : ""} 
                        ${activeTab === "tab3" ? "tab3-largesmm-screen-margin" : ""} 
                        ${activeTab === "tab4" ? "tab4-largesmm-screen-margin" : ""} 
                     ${activeTab === "tab5" ? "tab5-largesmm-screen-margin" : ""} 
                 
                    
                        `
        
                      }
                     >
                        {(() => {
                            const tabIndex = parseInt(activeTab.replace("tab", "")) - 1;
                            const contentArray = [
                                [
                                    <strong>Problem:</strong>,
                                    "Manufacturers rely on legacy IT and OT (Operational Technology) infrastructure, which lacks real-time security monitoring, network segmentation, and threat detection. Outdated systems are vulnerable to cyberattacks, downtime, and compliance violations.",
                                    <strong>How DREBCON Can Help:</strong>,
                                    " Implement Zero Trust Architecture (ZTA) and network segmentation to protect IT-OT convergence.",
                                    " 	Deploy AI-driven threat detection, endpoint security, and identity management solutions.",
                                    " Conduct cyber risk assessments, penetration testing, and vulnerability patching.",
                                    "Enable secure remote access for industrial control systems (ICS) and smart manufacturing devices.",
                                    <strong>Result:</strong>,
                                    "Resilient IT-OT infrastructure with proactive cybersecurity defenses.",
                                    "Reduced risk of cyber threats, ransomware, and data breaches.",
                                    "Improved compliance with ISO 27001.",
                                ],
                                [
                                    <strong>Problem:</strong>,
                                    " Manufacturing operations depend on real-time data processing and supply chain logistics. Without a business continuity and disaster recovery (BC/DR) strategy, cyberattacks, natural disasters, or system failures can halt production, disrupt supply chains, and cause financial losses.",
                                    <strong>How DREBCON Can Help:</strong>,
                                    " 	Design customized BC/DR frameworks for IT, OT, and industrial automation systems.",
                                    " 	Implement cloud-based disaster recovery (DRaaS) for minimal downtime.",
                                    "	Conduct disaster recovery drills, cyber incident simulations, and supply chain risk assessments.",
                                    <strong>Result:</strong>,
                                    "Resilient manufacturing operations with near-zero downtime.",
                                    "Continuous production, even during cyberattacks or natural disasters.",
                                    "Faster recovery from system failures, ensuring business continuity.",
                                ],
                                [
                                    <strong>Problem:</strong>,
                                    " Manufacturers operate on legacy ERP, MES (Manufacturing Execution Systems), and supply chain management (SCM) platforms that lack integration, automation, and scalability. This results in inefficiencies, data silos, and poor decision-making.",
                                    <strong>How DREBCON Can Help:</strong>,
                                    " Modernize ERP and manufacturing applications with cloud-based, AI-powered analytics.",
                                    " 	Enable seamless IT-OT integration for real-time production insights.",
                                    "	Automate inventory management, demand forecasting, and supplier collaboration.",
                                    "	Implement digital twins, predictive maintenance, and IoT-driven process automation.",
                                    <strong>Result:</strong>,
                                    "Optimized production workflows with real-time visibility.",
                                    "Faster, data-driven decision-making for supply chain and operations.",
                                    "Cost savings through automation, predictive maintenance, and reduced downtime.",
                                ],
                                [
                                    <strong>Problem:</strong>,
                                    "Many manufacturers still operate on on-premise IT infrastructure, limiting scalability, agility, and real-time data access. Manual processes, disconnected systems, and security risks slow down innovation.",
                                    <strong>How DREBCON Can Help:</strong>,
                                    "	Migrate ERP, SCM, and manufacturing applications to secure multi-cloud environments (AWS, Azure, GCP).",
                                    "	Deploy cloud-based industrial IoT (IIoT) platforms for real-time monitoring and automation.",
                                    "	Implement edge computing for faster data processing on the shop floor.",
                                    "	Enable hybrid cloud solutions for seamless IT-OT data exchange and analytics.",
                                    <strong>Result:</strong>,
                                    "Agile and scalable manufacturing operations with cloud-driven efficiency.",
                                    "Reduced IT costs, improved flexibility, and enhanced security.",
                                    "Real-time collaboration across global supply chains and production facilities.",
                                ],
                                [
                                    <strong>Problem:</strong>,
                                    " Manufacturers struggle to align IT investments with business goals, leading to inefficient resource allocation, AI-driven security monitoring, Zero Trust Architecture, and compliance frameworks. Security gaps, and compliance risks. Traditional IT security measures fail to protect modern Industry 4.0 environments.",
                                    <strong>How DREBCON Can Help:</strong>,
                                    " 	Develop customized IT security roadmaps aligned with business objectives.",
                                    " 	Implement AI-driven security monitoring, Zero Trust Architecture, and compliance frameworks.",
                                    "	Establish governance models for IT-OT cybersecurity, risk management, and compliance (ISO 27001, IEC 62443, NIST CSF).",
                                    "	Conduct continuous security assessments, workforce training, and cyber incident response planning.",
                                    <strong>Result:</strong>,
                                    "Business-driven IT strategy with cybersecurity resilience.",
                                    "Enhanced regulatory compliance and reduced cyber risk exposure.",
                                    "Stronger security posture to support Industry 4.0 .",
                                ],
                            ];

                            // Ensure the selected content is within range and not undefined
                            const selectedContent = contentArray[tabIndex] || [];

                            return selectedContent.map((point, index) => (
                                <ul key={index}>
                                    <li>{point}</li>
                                </ul>
                            ));
                        })()}


                        <button
                            style={styles.knowMoreButton}
                            onClick={handleKnowMoreClick}
                            onMouseEnter={(e) => (e.target.style.backgroundColor = "#e68a00")}
                            onMouseLeave={(e) => (e.target.style.backgroundColor = "rgb(236 115 34)")}
                            className="know-more-btn"
                        >
                            Know More
                        </button>
                    </div>
                </div>
            </div>

            {/* Dot Navigation for 3 Tabs */}
            <div style={styles.dotNav}>
                {[...Array(5)].map((_, index) => {
                    const tab = `tab${index + 1}`;
                    return (
                        <div
                            key={tab}
                            style={{
                                ...styles.dot,
                                ...(activeTab === tab ? styles.activeDot : {}),
                            }}
                            onClick={() => handleTabClick(tab)}
                        />
                    );
                })}
            </div>
        </div>

    );
};

export default Manufacturingthirdtab;
